{
  "name": "kaabalah",
  "version": "6.8.1",
  "description": "The de-facto library for any esoteric calculations and tooling",
  "engines": {
    "node": ">=18.18.0"
  },
  "bin": {
    "kaabalah": "dist/cli.js"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/mdnm/kaabalah.git"
  },
  "bugs": {
    "url": "https://github.com/mdnm/kaabalah/issues"
  },
  "homepage": "https://github.com/mdnm/kaabalah#readme",
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "exports": {
    "./swisseph-runtime": {
      "default": "./wasm/build/swisseph.js"
    },
    "./swisseph-wasm": "./wasm/build/swisseph.wasm",
    ".": {
      "types": "./dist/index.d.ts",
      "require": "./dist/index.js",
      "import": "./dist/index.mjs"
    },
    "./core": {
      "types": "./dist/core/index.d.ts",
      "require": "./dist/core/index.js",
      "import": "./dist/core/index.mjs"
    },
    "./numerology": {
      "types": "./dist/numerology/index.d.ts",
      "require": "./dist/numerology/index.js",
      "import": "./dist/numerology/index.mjs"
    },
    "./astrology": {
      "types": "./dist/astrology/index.d.ts",
      "require": "./dist/astrology/index.js",
      "import": "./dist/astrology/index.mjs"
    },
    "./gematria": {
      "types": "./dist/gematria/index.d.ts",
      "require": "./dist/gematria/index.js",
      "import": "./dist/gematria/index.mjs"
    },
    "./tarot": {
      "types": "./dist/tarot/index.d.ts",
      "require": "./dist/tarot/index.js",
      "import": "./dist/tarot/index.mjs"
    },
    "./ifa": {
      "types": "./dist/ifa/index.d.ts",
      "require": "./dist/ifa/index.js",
      "import": "./dist/ifa/index.mjs"
    },
    "./semantic": {
      "types": "./dist/semantic/index.d.ts",
      "require": "./dist/semantic/index.js",
      "import": "./dist/semantic/index.mjs"
    },
    "./visual": {
      "types": "./dist/visual/index.d.ts",
      "require": "./dist/visual/index.js",
      "import": "./dist/visual/index.mjs"
    }
  },
  "files": [
    "dist",
    "wasm/build",
    "ephe",
    "dist/cli.js"
  ],
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "test": "vitest run --silent",
    "test:watch": "vitest watch --silent",
    "test:coverage": "vitest run --coverage --silent",
    "test:ui": "vitest --ui --silent",
    "prepare-browser-test": "cp wasm/build/swisseph.wasm examples/ && cp -r ephe examples/",
    "generate:trees": "npx tsx examples/generate-tree-svg.ts",
    "generate:wheels": "npx tsx examples/generate-astro-wheel-svgs.ts",
    "generate:archeometer": "npx tsx examples/generate-archeometer-svg.ts",
    "generate:svgs": "npm run generate:trees && npm run generate:wheels && npm run generate:archeometer",
    "prepublishOnly": "npm run build && mkdir -p dist/wasm/build/ && cp dist/swisseph* dist/wasm/build/ && npm run generate:svgs"
  },
  "keywords": [
    "numerology",
    "astrology",
    "kabbalah",
    "mayan",
    "tzolkin",
    "hunab ku",
    "iching",
    "fengshui",
    "bagua",
    "gematria",
    "enneagram",
    "qabalah",
    "cabala",
    "tarot",
    "esoteric",
    "mysticism"
  ],
  "author": "Mat Moura <matmoura@kaabalah.com>",
  "license": "AGPL-3.0",
  "directories": {
    "doc": "docs",
    "example": "examples"
  },
  "dependencies": {
    "dotenv": "^17.3.1",
    "tz-lookup": "^6.1.25"
  },
  "devDependencies": {
    "@types/node": "20.11.5",
    "@vitest/coverage-v8": "1.3.1",
    "ts-node": "10.9.2",
    "tsup": "8.0.1",
    "typescript": "5.3.3",
    "vitest": "1.3.1"
  }
}
